var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.281,
    height: 57.358,
    viewBox: "0 0 48.281 57.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "book",
    d: "M86.554,30.473a2.24,2.24,0,0,0,2.24-2.24V2.244A2.24,2.24,0,0,0,86.554,0H51.779c-.021,0-.042,0-.063,0s-.042,0-.063,0H47.235a6.729,6.729,0,0,0-6.721,6.721V50.636a6.729,6.729,0,0,0,6.721,6.721H86.554a2.24,2.24,0,0,0,0-4.481H47.235a2.24,2.24,0,1,1,0-4.481H86.554a2.24,2.24,0,0,0,2.24-2.24V39.434a2.24,2.24,0,1,0-4.481,0v4.481H53.956V4.484H84.314V28.232A2.24,2.24,0,0,0,86.554,30.473ZM49.476,43.915h-2.24a6.69,6.69,0,0,0-2.24.385V6.724a2.243,2.243,0,0,1,2.24-2.24h2.24Zm27-30.582a2.24,2.24,0,1,1,0,4.481H61.8a2.24,2.24,0,1,1,0-4.481Z",
    transform: "translate(-40.514 0)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b0335ce0a48d71cb6b5834c9e8711b39.svg";
export { ForwardRef as ReactComponent };